import { z } from 'zod';

export enum ResetReason {
  MAINTENANCE = 'Maintenance',
  RECALIBRATION = 'Recalibration',
  REPLACEMENT = 'Replacement',
  OTHER = 'Other',
}

export const ResetReasonSchema = z.nativeEnum(ResetReason);
